<div class="field-dialog__content__scroll p-24" fxLayout="column" fusePerfectScrollbar>
  <div *ngIf="recurrenceLogsMapped?.length">
    <ng-container *ngFor="let recurrenceLog of recurrenceLogsMapped; index as index">
      <div
        *ngIf="recurrenceLogsMapped[index - 1]?.formattedCreatedAt !== recurrenceLog?.formattedCreatedAt"
        class="log-date font-color-gray"
      >
        <p *ngIf="recurrenceLog.formattedCreatedAt === todayDate">
          {{ 'RECURRENCES.DIALOG.TABS.HISTORIC.TODAY' | translate }}
        </p>
        <p *ngIf="recurrenceLog.formattedCreatedAt === yesterdayDate">
          {{ 'RECURRENCES.DIALOG.TABS.HISTORIC.YESTERDAY' | translate }}
        </p>
        <p *ngIf="recurrenceLog.formattedCreatedAt !== yesterdayDate && recurrenceLog.formattedCreatedAt !== todayDate">
          {{ recurrenceLog.formattedCreatedAt }}
        </p>
      </div>

      <div class="log">
        <div class="log-icon-wrapper">
          <div class="log-icon {{ recurrenceLog.colorClass }}-bg">
            <img src="assets/images/icons/{{ recurrenceLog.icon }}.svg" [alt]="recurrenceLog.eventName" />
          </div>
          <span class="log-line"></span>
        </div>

        <div class="card mb-0">
          <div class="card__item mt-0">
            <div class="log-title">
              <div class="log-title__description">
                <span
                  class="log-event-type {{ recurrenceLog.colorClass }}-text"
                  [innerHTML]="recurrenceLog.eventName"
                ></span>
              </div>
              <div class="log-title__date font-color-gray">
                {{ recurrenceLog.createdAt }}
              </div>
            </div>
            <div *ngIf="recurrenceLog.customAuthor" class="log-author-and-device font-color-gray">
              <mat-icon inline>{{ recurrenceLog.customAuthorDevice }}</mat-icon>
              <span>{{ recurrenceLog.customAuthor }}.</span>
            </div>

            <div *ngIf="recurrenceLog.snapshot" class="font-color-gray">
              <p *ngIf="recurrenceLog.snapshot.message && recurrenceLog.showMessage" class="log-description">
                {{ recurrenceLog.snapshot.message }}
              </p>
              <p
                *ngIf="recurrenceLog.eventDescription"
                [innerHTML]="recurrenceLog.eventDescription"
                class="log-description"
              ></p>

              <div class="mt-20" *ngIf="recurrenceLog.showLinks">
                <ng-container
                  *ngIf="!recurrenceLog.links.sectors.length && !recurrenceLog.links.equipmentsWithoutSector.length"
                >
                  {{ 'RECURRENCES.DIALOG.TABS.HISTORIC.NO_LINKS' | translate }}
                </ng-container>

                <ng-container
                  *ngIf="recurrenceLog.links.sectors.length || recurrenceLog.links.equipmentsWithoutSector.length"
                >
                  <div class="log__links__tree">
                    <div class="log__links__tree__node" *ngFor="let sector of recurrenceLog.links.sectors">
                      <fc-tree-view [item]="sector"></fc-tree-view>
                    </div>

                    <div
                      class="log__links__tree__node"
                      *ngFor="let equipment of recurrenceLog.links.equipmentsWithoutSector"
                    >
                      <fc-tree-view [item]="equipment"></fc-tree-view>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!recurrenceLogsMapped?.length" fxLayout="column" fxLayoutAlign="center center" class="p-24">
    <p fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
      <mat-icon class="font-size-32">history</mat-icon>
    </p>
    <span class="h3">
      {{ 'RECURRENCES.DIALOG.TABS.HISTORIC.NO_HISTORIC' | translate }}
    </span>
  </div>
</div>
